export default __webpack_public_path__ + "static/media/image8.5016fc4b.png";